import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { VisitDetailPhotos } from '@types-lib';
import { ENVIRONMENT, PIMSEnvironment } from 'environments';
import { Observable } from 'rxjs';

export class AdditionalExamPhotosEndpoint {
  private env = inject<PIMSEnvironment>(ENVIRONMENT);
  private http = inject(HttpClient);

  post(visitId: number, payload: VisitDetailPhotos.RequestAdditionalExamPhoto): Observable<any> {
    return this.http.post(
      `${this.env.constants.ADMIN_API_URL}/admin/orders/${visitId}/visitphotos/additional`,
      payload,
    );
  }
}
